/*
 * @Author: 戴旭
 * @Date: 2023-02-17 16:07:58
 * @LastEditTime: 2023-10-24 18:07:11
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\cloud-visit\cloud-visit\module\contextManageRouter.js
 * 内容管理
 */

const contextManageRouter = [
  // 云拜访列表
  {
    path: '/outsideSystem/visiting/cloud',
    name: 'behaviorManageVisitingCloud',
    component: () =>
      import(
        /*webpackChunkName:"flowSystem6" */
        '@/views/cloud-visit/cloud-visit/context-manage/cloud-visit/Page.vue'
        ),
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      isMoreMeta: false,
      1: {
        title: '拜访列表',
      },
      2: {
        title: '协访列表',
      },
    },
  },

  // 云资料
  {
    path: '/outsideSystem/data-bank/List',
    name: 'outsideSystemDataBankList',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemDataBankList" */
        '@/views/outsideSystem/data-bank/List.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '云资料',
    },
  },


  // 云资料 分类设置
  {
    path: '/outsideSystem/data-bank/classificationSettings',
    name: 'outsideSystemDataBankClassificationSettings',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemDataBankClassificationSettings" */
        '@/views/cloud-visit/cloud-visit/context-manage/cloud-data/Share.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '分类设置',
      breadcrumb: [{
        title: '云资料',
        name: 'outsideSystemDataBankList',
      }, ],
    },
  },


  // 云资料 编辑/添加资料
  {
    path: '/outsideSystem/data-bank/add-edit/:study_material_id/:meta_type',
    name: 'outsideSystemDataBankEditAdd',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemDataBankEditAdd" */
        '@/views/cloud-visit/cloud-visit/context-manage/cloud-data/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑资料',
        breadcrumb: [{
          title: '云资料',
          name: 'outsideSystemDataBankList',
        }, ],
      },
      2: {
        title: '添加资料',
        breadcrumb: [{
          title: '云资料',
          name: 'outsideSystemDataBankList',
        }, ],
      },
    },
  },


  // 云资料详情
  {
    path: '/outsideSystem/data-bank/detail/:study_material_id',
    name: 'outsideSystemDataBankDetail',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemDataBankDetail" */
        '@/views/outsideSystem/data-bank/Detail.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '云资料详情',
      breadcrumb: [{
        title: '云资料',
        name: 'outsideSystemDataBankList',
      }, ],
    },
  },
  // 线上问卷
  {
    path: '/outsideSystem/online-questionnaire/:isFrom',
    name: 'onlineQuestionnaire',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageSurveyQuestionnaireList" */
        '@/views/cloud-visit/cloud-visit/context-manage/online-questionnaire/Page.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '线上问卷',
    },
  },

  // 线上问卷 新建问卷
  {
    path: '/outsideSystem/create-questionnaire/:id/:isFrom',
    name: 'outsideSystemCreateQuestionnaire',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageCreateQuestionnaire" */
        '@/views/cloud-visit/cloud-visit/context-manage/online-questionnaire/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '新建问卷',
      breadcrumb: [{
        title: '调查问卷',
        name: 'behaviorManageSurveyQuestionnaireList',
      }, ],
    },
  },


  // 线上问卷 数据结果
  {
    path: '/outsideSystem/questionnaire-result/:id/:type/:activity_id/:isFrom',
    name: 'outsideSystemQuestionnaireResult',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageQuestionnaireResult" */
        '@/views/cloud-visit/cloud-visit/context-manage/online-questionnaire/Result.vue'
        ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '数据结果',
      breadcrumb: [{
        title: '调查问卷',
        name: 'behaviorManageSurveyQuestionnaireList',
      }, ],
    },
  },

]

export default contextManageRouter